module.exports = __webpack_public_path__ + "static/img/supplier1.81cbdec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplier1.png
// module id = D3gz
// module chunks = 192